import { useMutation } from "urql";

import { UpdateTransactionHistoryDocument } from "../../../graphql/generated.ts";

export const useUpdateTransactionHistory = () =>
  useMutation(UpdateTransactionHistoryDocument);
